/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../../common/commonComponents/containerInventoryTable";

export const getColumns = (t: any): Column[] => [
  {
    header: t("containerInventory.tableColumns.sl_no"),
    key: "slno",
  },

  {
    header: t("containerInventory.tableColumns.batchCode"),
    key: "batch_code",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-[11.5px] font-medium text-[#FF7043] uppercase tracking-wide bg-orange-50 px-2 py-0.5 rounded border border-orange-100">
          {row.batchCode}
        </span>
      </td>
    ),
  },

  {
    header: t("containerInventory.tableColumns.container_lot_identifier"),
    key: "container_type",
    render: (row) => (
      <td className="px-8 py-2">
        <div className="flex items-center gap-2 whitespace-nowrap">

          <div
            className={`w-7 h-7 ${row.iconBg} rounded-xl flex items-center justify-center`}
          >
            <span className="material-symbols-outlined text-xl">
              {row.icon}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-xs font-medium text-slate-800 uppercase tracking-tight">
              {row.containerName}
            </span>
          </div>

        </div>
      </td>
    ),
  },
  

  {
    header: t("containerInventory.tableColumns.size"),
    key: "size",
    render: (row) => (
      <td className="px-8 py-2 text-center whitespace-nowrap">
        <span className="text-xs font-medium text-slate-800 uppercase">
          {row.size}
        </span>
      </td>
    ),
  },

  // {
  //   header: t("containerInventory.tableColumns.manufacturer"),
  //   key: "manufacturer",
  //   render: (row) => (
  //     <td className="px-8 py-6 text-center">
  //       <span className="text-xs font-medium text-slate-800">
  //         {row.manufacturer}
  //       </span>
  //     </td>
  //   ),
  // },

  {
    header: t("containerInventory.tableColumns.quantity"),
    key: "quantity",
    render: (row) => (
      <td className="px-8 py-2 text-center whitespace-nowrap">
        <span className="text-xs font-medium text-slate-800 uppercase tracking-tight">
          {row.quantity} Units
        </span>
      </td>
    ),
  },
];